import { action, makeObservable, observable, runInAction } from 'mobx';
import { SnackbarProps } from '@servicetitan/design-system';
import { inject, injectable } from '@servicetitan/react-ioc';
import { NotificationsService } from '@servicetitan/notifications';

@injectable()
export class NotificationsStore {
    @observable snackbarNotification?: SnackbarProps;

    constructor(@inject(NotificationsService) readonly defaultService: NotificationsService) {
        makeObservable(this);
    }

    @action notifyInSnackbar = (notification: SnackbarProps) => {
        this.removeSnackbar();

        if (notification.onActionClick) {
            const actionClickHandler = notification.onActionClick;

            notification.onActionClick = (...args) => {
                actionClickHandler(...args);
                this.removeSnackbar();
            };
        }

        notification.onClose = this.removeSnackbar;

        // in order user notices the new notification
        setTimeout(() => {
            runInAction(() => {
                this.snackbarNotification = notification;
            });
        }, 0);
    };

    @action removeSnackbar = () => {
        this.snackbarNotification = undefined;
    };
}
